
import Vue from "vue";
import HeroBanner from "@/components/common/HeroBanner.vue";
import BreadCrumb from "@/components/common/BreadCrumb.vue";
import store from "@/store";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";
import { IBreadCrumbRoute } from "@/types";
import HowToAppyContent from "@/components/HowToApplyContent.vue";

export default Vue.extend({
  name: "how-to-apply",
  components: { HeroBanner, BreadCrumb, HowToAppyContent },
  mixins: [UIFeatureMixin],
  data() {
    return {
      description:
        "Pennsylvania offers many transportation services to meet your needs.",
      routes: [
        { to: { name: "home" }, text: "Home" },
        {
          to: { name: "howToApply" },
          text: "How to Apply",
        },
      ] as Array<IBreadCrumbRoute>,
    };
  },
  created() {
    store.dispatch.uiFeatureModule.getUIFeatures(
      "HOW_APPL,APP_OVRWV,HTA_HERO_C,HTA_CON_1A,HTA_CON_1B,HTA_CON_2A,HTA_CON_2B,HTA_CON_2C,HTA_CON_3A,HTA_NEED_H,HTA_FOOTER,HME_THIS,NCOUNTY_1,NCOUNTY_2,NCOUNTY_3,AVAIL_CNTY,AVL_COUNTY,QUICK_SRCH,ER_INLINE,CHGLGN_TXT,ADMN_USR,MAIN,MAIN_TITLE,FMR,ENVRONMNT,ADA,FTP,MATP,PWD,SSR,CNTCT_US,CNT_US_C,SEL_CNTY,FLT_CNTIES"
    );
  },
  computed: {
    isDataLoading: {
      get(): boolean {
        return store.getters.uiFeatureModule.getLoadingStatus;
      },
    },
  },
});
